module.exports = __webpack_public_path__ + "img/c2.5fa34573.jpg";